import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Alle alten Service Worker sofort entfernen (verursachen "body stream already read")
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then(regs => {
    regs.forEach(r => r.unregister());
  });
}

// Globaler Fetch-Interceptor: Fügt automatisch JWT-Token an alle /api/ Requests
const originalFetch = window.fetch;
window.fetch = function(url, options = {}) {
  const urlStr = typeof url === 'string' ? url : url?.url || '';
  if (urlStr.includes('/api/') && !urlStr.includes('/api/auth/login')) {
    const token = localStorage.getItem('olympus_token');
    if (token) {
      options = { ...options };
      options.headers = {
        ...options.headers,
        'Authorization': `Bearer ${token}`,
      };
    }
  }
  return originalFetch.call(this, url, options);
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
